import React, { useEffect, useState } from "react";
import Modal from "@components/atoms/Modal";
import { BulkListModalProps } from "./types";
import { useBulkRequestSlice } from "@redux/slices/bulkRequestSlice";
import BulkListSummary from "@components/organisms/BulkListSummary";
import Routes from "@navigations/Routes";
import { navigate } from "@navigations/utils/RootNavigation";
import { useTranslation } from "react-i18next";
import { StoneType } from "@scenes/bulk-request/Utils";

const BulkListModal = ({ isOpen, onClose }: BulkListModalProps) => {
  const bulkRequestSlice = useBulkRequestSlice();
  const totalProductCount = bulkRequestSlice.totalProductCount();
  const bulkItemData = bulkRequestSlice.bulkItemData;
  const [totalCount, setTotalCount] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const _bulkTotalCount = bulkItemData.reduce((total: number, curr: any) => {
      const count = total + Number(curr.total_count ?? 0);
      return count;
    }, 0);
    setTotalCount(_bulkTotalCount);
  }, [bulkItemData]);

  const navigateToBulkRequestScreen = (
    product_type: any,
    stone_type?: StoneType
  ) => {
    onClose();
    navigate(Routes.BulkRequestNavigator, {
      screen: Routes.BulkRequestScreen,
      params: {
        productType: product_type,
        stone_type: stone_type,
      },
    });
  };

  return (
    <Modal
      headerTitle={`${t("navigationMenu.web.bulkList.text")} (${totalCount})`}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={16}
      paddingRight={16}
      paddingBottom={32}
      paddingTop={16}
    >
      {totalProductCount > 0 && (
        <BulkListSummary navigateToBulkScreen={navigateToBulkRequestScreen} />
      )}
    </Modal>
  );
};

export default BulkListModal;
